import styled from 'styled-components';
import { Colors, FontSize, FontWeight } from '../../../assets/GlobalStyle/Variables';

export const StyledSelectWrapper = styled.div<{ $hasError?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0px;
  line-height: 30px;
  height: 40px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 0px;
  color: ${Colors.grey};
  font-size: ${FontSize.normal};
  background: transparent;

  &:focus {
    outline: none;
    border: 1px solid ${(props) => (props.$hasError ? Colors.error : Colors.disabledHover)};
  }

  .styled__react-select {
    flex: 1;
  }
`;

export const StyledLabel = styled.label`
  margin: 0;
  color: ${Colors.grey};
  font-weight: ${FontWeight.strong};
  font-size: ${FontSize.normal};
  white-space: nowrap;
  min-width: 200px;
`;
